'use client';

import { useEffect } from 'react';
import { Module } from '@/components/utilities/content-modules/module-list/module-list';
import ModuleList, {
  ModuleListProps,
} from '@/components/utilities/content-modules/module-list/module-list';
import {
  trackPageLoadEvent,
  trackViewEvent,
} from '@/integrations/tracking/google-tag-manager/scripts';
import { tealiumView } from '@/integrations/tracking/tealium/scripts';

export interface PageProps extends ModuleListProps {
  $type?: string;
  /** An array of the modules to show */
  modules: Module[];
  /** Personalization data for the user */
  personalizationData?: Content.Properties.PersonalizationData;
  /** Tracking data for the page */
  trackingData?: Content.Properties.TrackingData;
}

const Page = ({
  $type,
  modules,
  personalizationData,
  trackingData,
}: PageProps) => {
  useEffect(() => {
    trackPageLoadEvent({
      content_group: $type === 'HomePageDto' ? 'frontpage' : 'content',
    });

    personalizationData && tealiumView(personalizationData);

    if (!trackingData?.gtmDataLayer) return;

    trackViewEvent(trackingData.gtmDataLayer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <ModuleList modules={modules} />
    </div>
  );
};

Page.displayName = 'Page';

export default Page;
